import { EAccessType } from 'app/core/permissions/enum/access.enum';

export interface IAuthentication {
    expiresIn: number;
    accessToken: string;
    refreshToken: string;
}

export interface IUserLoginSocial {
    userId: string;
    accessToken: string;
}

export interface ILogin {
    email?: string;
    password?: string;
    provider?: IProvider;
}

export interface IProvider {
    name: 'facebook' | 'google' | 'apple';
    token: string;
    clientType: 'web' | 'mobile';
}

export interface IForgotPassword {
    email: string;
    type: EAccessType;
}

export interface IResetPassword {
    token: string;
    password: string;
}

export interface IRefreshToken {
    refreshToken: string;
}

export enum EAuthenticationStorage {
    TOKEN = 'k-token-clinic-admin',
    TIME_TOKEN = 'k-time-token-clinic-admin',
    REFRESH_TOKEN = 'k-refresh-token-clinic-admin',
    USER = 'k-user-clinic-admin',
    X_DEVICE_TOKEN = 'x-device-token',
    CLINIC = 'k-clinic',
    CLINICS = 'k-clinics',
    CLINIC_ID = 'k-clinic-id',
    LABORATORY_ID = 'k-selected-laboratory-id',
    LOCATIONS = 'k-locations',
    LOCATION_IDS = 'k-location-ids',
    LANG = 'k-lang',
}

export enum ELocalStorage {
    SCHEME = 'k-color-scheme',
    RECEIVABLE_VISIBLE = 'k-receivable-visible',
    SERVICE_CODE_VISIBLE = 'k-service-code-visible',
    // tag
    TAG_IDENTIFICATION_CODE = 'k-identification-code',
    TAG_IDENTIFICATION_TYPE = 'k-identification-type',
    TAG_LABEL_TYPE = 'k-label-type',
    TAG_DELIVERY_PROTOCOL_TYPE = 'k-delivery-protocol-type',
    TAG_DELIVERY_PROTOCOL_PRINT_COPY = 'k-delivery-protocol-print-copy',
    TAG_CUSTOMER_TYPE = 'k-customer-type',
    TAG_CUSTOMER_LABEL_TYPE = 'k-customer-label-type',
    // schedule
    K_PRODUCTION_TYPE = 'k-production-type',
    K_PRODUCTION_DATE_TYPE = 'k-production-date-type',
    K_PRODUCTION_IS_DEFINED_PRODUCTION = 'k-production-is-defined-production',
    // PRODUCT
    PRODUCT_BULK_SCANN_ENABLED = 'k-product-bulk-scann-enabled',
    // DEVICE
    K_DEVICE_ID = 'k-device-id',
    K_DEVICE_NOTIFICATION_ENABLED = 'k-device-notification-enabled',
    K_DEVICE_NOTIFICATION_HIDDEN = 'k-device-notification-hidden',
    // NOTIFICATIONS
    K_UNREAD_NOTIFICATION = 'k-unread-notification',
}

export type IVerifyEmail = {
    email: string;
};
